<div class="site-header">

    <div *ngIf="layout === 'classic'" class="site-header__middle container">
        <div class="site-header__logo">
            <a routerLink="/">
                <img style="width: auto; height: 60px;" [src]="siteService.siteSetting?.logo?.url || 'assets/svg/logo-main.svg'" />
            </a>
        </div>

        <div class="topbar__item">
            <div class="topbar-dropdown" appDropdown="topbar-dropdown--opened" #languageDropdown="appDropdown">
                <button class="topbar-dropdown__btn" type="button"
                    (click)="countries.length > 1? languageDropdown.toggle() : citiesModal(countries[0])">

                    <div *ngIf="false">
                        <mat-icon matTooltip="{{'location'|translate}}">room</mat-icon> {{'location'|translate}}
                        <span class="topbar__item-value">{{translateHelper.localize(currentCountry?.name)}}</span>
                        <app-icon name="arrow-rounded-down-7x5" size="7x5"></app-icon>
                    </div>


                    <div *ngIf="true" class="flex flex-row justify-items-center items-center">
                        <img *ngIf="currentCountry?.code =='BHR' || currentCountry?.code == 'KSA'" width="33"
                            [src]="'assets/images/flags/'+currentCountry?.code+'.png'" class="mx-1 rounded-full">
                        <div class="topbar__item-value">{{translateHelper.localize(currentCountry?.name)}}</div>
                    </div>

                </button>

                <div class="topbar-dropdown__body mx-5">

                    <div *ngIf="countries?.length == 0 || !countries"
                        class="menu menu--layout--topbar menu--with-icons justify-center">
                        <mat-spinner [diameter]="52"></mat-spinner>
                    </div>

                    <div class="menu menu--layout--topbar menu--with-icons">


                        <ul class="menu__list">
                            <li class="menu__item" *ngFor="let country of countries"
                                (mouseover)="menuItem.classList.add('menu__item--hover')"
                                (mouseleave)="menuItem.classList.remove('menu__item--hover')" #menuItem>
                                <button class="menu__item-link" type="button"
                                    (click)="changeCountry(country, languageDropdown)">
                                    <span class="menu__item-icon">
                                        <img *ngIf="country.code =='BHR' || country.code == 'KSA'" width="28"
                                            [src]="'assets/images/flags/'+country.code+'.png'">
                                    </span>
                                    {{ translateHelper.localize(country.name) }}
                                </button>
                            </li>
                        </ul>
                    </div>



                    <div *ngIf="currentCountry && countries.includes(currentCountry)"
                        class="menu menu--layout--topbar menu--with-icons">

                    </div>


                </div>
            </div>
        </div>

        <div class="site-header__search">
            <app-search location="header"></app-search>
        </div>

        <app-header-links class="nav-panel__nav-links nav-links"></app-header-links>
        <div class="nav-panel__indicators">
            <app-indicator [icon]="translateService.currentLang == 'ar'? 'en2ar' : 'ar2en'" size="37"
                [title]="translateService.currentLang == 'ar'? 'Switch To English' : 'Switch To Arabic'" trigger="click"
                (buttonClick)="translateService.currentLang == 'ar'? changeLangage('en'): changeLangage('ar')"
                #indicator3="appIndicator">
            </app-indicator>

            <app-indicator link="./cart" icon="cart-20" trigger="click" title="Cart" [counter]="cart.quantity$|async"
                (buttonClick)="onCartClick()" #indicator="appIndicator">
                <app-header-dropcart *ngIf="dropcartType == 'dropdown'" (closeMenu)="indicator.close(false)">
                </app-header-dropcart>
            </app-indicator>

            <app-indicator [routerLink]="['account/quotation-drafts']" icon="quotation-20" title="Quotations"
                trigger="click" [counter]="quotationCart.quantity$|async" #indicator3="appIndicator">
            </app-indicator>

            <app-indicator link="./account" icon="person-20" trigger="click" title="Account" #indicator1="appIndicator">
                <app-account-menu (closeMenu)="indicator1.close(false)"></app-account-menu>
            </app-indicator>
        </div>
    </div>

</div>

<app-header-topbar></app-header-topbar>
<app-categories-underbar></app-categories-underbar>
